/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import createHttpClient from 'store/httpClient';
import { fromObjectToQueryString } from 'utils/api';
import { stockEndPoints } from 'api/stock/constants';
import {
  TStockCreateBE,
  TStockCreateBody,
  TStockGetListBE,
  TStockGetListQueryParams,
  TStockUpdateBE,
  TStockUpdateBody,
} from 'api/stock/stock.types';

export const getStockListAsyncThunk = createAsyncThunk<
  TStockGetListBE['data'],
  { queryParams: TStockGetListQueryParams } | void
>('stock/getList', async (args, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.get<TStockGetListBE>(
      stockEndPoints.getList(
        fromObjectToQueryString(
          typeof args === 'object' ? args?.queryParams : {}
        )
      )
    );

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

export const createStockAsyncThunk = createAsyncThunk<
  TStockCreateBE['data'],
  { body: TStockCreateBody; onSuccess?: () => void }
>('stock/create', async ({ body, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);
    const response = await httpClient.post<TStockCreateBE, TStockCreateBody>(
      stockEndPoints.create(),
      body
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

export const updateStockAsyncThunk = createAsyncThunk<
  TStockUpdateBE['data'],
  { id: string; body: TStockUpdateBody; onSuccess?: () => void }
>('stock/update', async ({ id, body, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);
    const response = await httpClient.put<TStockUpdateBE, TStockUpdateBody>(
      stockEndPoints.update(id),
      body
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});
